"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actor = void 0;
/**
 * An actor which can be a person or a system interacting with echain concerns.
 */
var Actor;
(function (Actor) {
    /** The person working in the factory assembling echain systems. */
    Actor["AssemblerPerson"] = "AssemblerPerson";
    /** The person interested in purchasing products from igus. */
    Actor["CustomerPerson"] = "CustomerPerson";
    /** The person selling igus products to customers. */
    Actor["SalesPerson"] = "SalesPerson";
    /** The person using the current browser application. */
    Actor["UserPerson"] = "UserPerson";
    /** The ERP System used by the igus factory and other backoffice actors. */
    Actor["ErpSystem"] = "ErpSystem";
    /** The Salesforce CRM System used by igus employees to manage customers and quotes. */
    Actor["ISalesSystem"] = "ISalesSystem";
    /** The webshop of igus. */
    Actor["ShopSystem"] = "ShopSystem";
    /**
     * The iQuote system used by `SalesPerson` to create quotes for `CustomerPerson`.
     * Use this when iQuote app or any data layer communicates with another actor.
     */
    Actor["IQuoteSystem"] = "IQuoteSystem";
    /**
     * The expert system used by `CustomerPerson` or `SalesPerson` to create quotes for `CustomerPerson`.
     * Use this when Expert app or any data layer communicates with another actor.
     */
    Actor["ExpertSystem"] = "ExpertSystem";
})(Actor = exports.Actor || (exports.Actor = {}));
//# sourceMappingURL=Actor.js.map